import { styled } from '@mui/material';
import { Card } from './Card.js';
export const InputCard = styled(Card, {
    name: 'MuiInputCard',
    slot: 'root',
})({});
//# sourceMappingURL=InputCard.js.map